var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePinterestLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.915,
    cy: 11.915,
    r: 11.915,
    fill: "#CB2027"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.915,
    cy: 11.915,
    r: 11.915,
    fill: "#5F787E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.877 15.955c-.901-.07-1.28-.516-1.986-.945-.388 2.037-.863 3.99-2.268 5.01-.435-3.079.637-5.391 1.134-7.846-.848-1.427.102-4.3 1.89-3.592 2.201.87-1.905 5.307.851 5.86 2.879.58 4.054-4.993 2.269-6.806-2.58-2.616-7.507-.059-6.9 3.687.147.916 1.093 1.194.377 2.458-1.65-.366-2.143-1.668-2.08-3.403.103-2.84 2.553-4.83 5.01-5.105 3.11-.348 6.027 1.141 6.43 4.065.452 3.3-1.404 6.874-4.727 6.617z",
    fill: "#fff"
  })));
}
export default SvgMobilePinterestLogo;